/*=========================================================================================
  File Name: frontendActions.js
  Description: Vuex Store - frontend actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';
import getters from '../getters';

export default {
    /**
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    submitContactForm({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/form/submit', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
}
